import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=544cc295&"
import script from "./ProductBox.js?vue&type=script&lang=js&"
export * from "./ProductBox.js?vue&type=script&lang=js&"
import style0 from "./ProductBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports